export function DebugState({ id, user, isUserLoading, itineraryRef, itinerary, isItineraryLoading, isLoading, error }: any) {
    const refPath = itineraryRef ? itineraryRef.path : 'null';

    return (
        <div className="container mx-auto mt-8 p-4 border-2 border-dashed rounded-lg bg-card text-card-foreground font-mono text-sm">
            <h1 className="text-xl font-bold mb-4">Live State Debug Panel</h1>
            <div className="grid grid-cols-2 gap-x-8 gap-y-2">
                <p>URL Itinerary ID:</p><p className="font-bold">{id}</p>
                <p>--</p><p>--</p>
                <p>User Loading:</p><p className={isUserLoading ? 'text-yellow-400' : 'text-green-400'}>{String(isUserLoading)}</p>
                <p>User Object:</p><p>{user ? `UID: ${user.uid}` : 'null'}</p>
                <p>--</p><p>--</p>
                <p>Itinerary Ref Path:</p><p className="break-all">{refPath}</p>
                <p>Itinerary Loading:</p><p className={isItineraryLoading ? 'text-yellow-400' : 'text-green-400'}>{String(isItineraryLoading)}</p>
                <p>Itinerary Data:</p><p>{itinerary ? `ID: ${itinerary.id}` : 'null'}</p>
                <p>--</p><p>--</p>
                <p>Combined Loading State:</p><p className={isLoading ? 'text-yellow-400' : 'text-green-400'}>{String(isLoading)}</p>
                <p>Firestore Error:</p><p className="text-red-400">{error ? error.message : 'null'}</p>
            </div>
             <p className="mt-6 text-center bg-background p-2 rounded-md">Page is showing this debug panel because `!isLoading` is true but `!itinerary` is also true.</p>
        </div>
    )
}
